import { Component, OnInit } from '@angular/core';
import {Location} from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HelpersService } from '../../../services/tools/helpers.service';
import { FondeadoresService } from '../../../services/fondeadores.service';
import { MatDialog } from '@angular/material';
import { IncrementarInversionModalComponent } from './incrementar-inversion-modal/incrementar-inversion-modal.component';
import { DevolucionesInversionModalComponent } from './devoluciones-inversion-modal/devoluciones-inversion-modal.component';
import { PagosInversionModalComponent } from './pagos-inversion-modal/pagos-inversion-modal.component';
import { PagosFondeadoresService } from '../../../services/pagos-fondeadores.service';
import { EsquemaInversionService } from '../../../services/esquema-inversion.service';
import { DatesHelpersService } from '../../../services/tools/dates-helpers.service';
import { EliminarPagoModalComponent } from './pagos-inversion-modal/eliminar-pago-modal/eliminar-pago-modal.component';
import { EliminarRetiroModalComponent } from './devoluciones-inversion-modal/eliminar-retiro-modal/eliminar-retiro-modal.component';
import { AutenticacionService } from '../../../services/autenticacion.service';
import { EliminarEsquemaModalComponent } from './eliminar-esquema-modal/eliminar-esquema-modal.component';

@Component({
  selector: 'app-detalles-inversion',
  templateUrl: './detalles-inversion.component.html',
  styleUrls: ['./detalles-inversion.component.scss']
})
export class DetallesInversionComponent implements OnInit {
  public pagos_de_ciclos = [];
  public pagos:boolean = false;
  public isLoading: boolean = false;
  public inversionId : number = 0;
  public fondeadorID : number = 0;
  public inversion : any = {};
  public inversiones_fondeador : any [] = [];
  public lista_incrementos : any [] = [];
  public tabla_inversion: any[] = [];
  public numMeses: number = 0;
  public esAhorrador : boolean = false;
  public fechaTemp: any = null;
  //Variables de apoyo
  public incremento_interes:number = 0;
  public incremento_pago:number = 0;
  //Devoluciones
  public lista_devoluciones : any [] = [];
  public total: number = 0;
  public nuevoArray: any[] = [];
  //public incremento_inversion : any = {};
  //Variables para ahorradores
  public total_aportaciones : number = 0;
  public rendimiento_total : number = 0;
  public total_iva : number = 0;
  public total_neto : number = 0;
  public ahorro_total : number = 0;
  public total_estimado : number = 0;
  public total_dias_transcurridos : number = 0;
  //Todos pagos
  public todo_pagado: boolean = false;
  //Inversiones con pagos
  public inversiones_con_pagos : any [] = [];
  //Para pagos
  public lista_pagos: any[] = [];
  //Login del fondeador
  public isLoginFondeador: boolean = false;
  //Rendimiento ganado
  public rendimiento_ganado = 0;
  //Fecha
  public fecha_actual: any;
  public isRetiroFinal: boolean = false;
  public finEsquemaAhorro: boolean = false;
  //Para inversionistas
  public total_inversion : number = 0;
  public total_intereses : number = 0;
  public total_despues_impuestos : number = 0;
  public dias_restantes : number = 0;
  public pago_inicial: boolean = false;

  constructor(
    public location : Location,
    private fondeadoresService: FondeadoresService,
    private esquemaInversionService: EsquemaInversionService,
    private activatedRoute : ActivatedRoute,
    private helperService : HelpersService,
    public dialog: MatDialog,
    private pagosFondeadoresService: PagosFondeadoresService,
    private datesHelper : DatesHelpersService,
    private autenticacionService:AutenticacionService,
  ) { }

  async ngOnInit() {
    this.fondeadorID = this.activatedRoute.snapshot.params.idFondeador;
    this.inversionId = this.activatedRoute.snapshot.params.idEsquemaInversion;
    //Verificamos que no sea un login de Fondeador
    var userFondeador= localStorage.getItem("User_fondeador");
    if(userFondeador != null){
      var datosTemp = JSON.parse(userFondeador);
      this.isLoginFondeador = datosTemp.isFondeador;
      console.log("LoginF: ", this.isLoginFondeador);
    }
    
    //Obtener fecha actual
    let defaultDates = this.datesHelper.getMonthDate();
    //let fecha_temp = new Date("2022-09-26").toISOString();
    let fecha_temp = new Date(defaultDates.fechaFin).toISOString();
    this.fecha_actual = fecha_temp.split("T")[0];
    console.log("Fecha Act. ", this.fecha_actual);
    console.log("ES AMDIN", this.autenticacionService.isAdmin())
    //setTimeout(() => {this.actualizarConDevoluciones()},3000);
    

    // this.aplicarIncrementosBD(this.inversionId)
    this.lista_devoluciones = await this.obtenerDevolucionesInversion(this.inversionId);
    let continuar = await this.obtInversionId(this.inversionId);
    let incrementos_temp = [];
    console.log(continuar);
    if (continuar == "OK"){
      console.log("Calculamos tabla de inversion")
      continuar = await this.calcularTablaInversion();
    }
    if (continuar){
      console.log("aplicamos incrementos")
      this.lista_incrementos = await this.aplicarIncrementosBD(this.inversionId)
    }
    if(this.lista_incrementos.length > 0){
      this.calcularIncrementos();
    }else{
      this.obtenerPagosInversion();
    }

    if(this.lista_devoluciones.length > 0){
      this.calcularTablaConDevoluciones();
    }

    this.limpiarCamposTabla();

  }

  ngAfterViewInit(): void {
    // this.obtenerPagosInversion();
  }
  public eliminarEsquema(){
    const dialogRef = this.dialog.open(EliminarEsquemaModalComponent,{
      data: {inversiones: this.inversiones_fondeador, idEsquema: this.inversionId, idFondeador: this.fondeadorID, limites:this.pagos_de_ciclos},
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result.pagado){
        console.log("Esquema eliminado");
      }
    });
  }

  public obtInversionId(id: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.inversion = {};
      this.inversiones_fondeador = [];
      this.isLoading = true;
      this.fondeadoresService.getEsquemaInversionById(id).subscribe(
        (response)=>{
          const jsonResult = response.json();
          if(jsonResult.content){
            this.inversion = jsonResult.content[0];
            var fechaPago = this.inversion.fecha_inicio_inversion;
            //Obtenemos el dia del pago
            fechaPago = fechaPago.split(" ")[0].split("-")[2];
  
            console.log("Inversión ID: ", this.inversion);
  
            if(this.inversion.capitalizacion == 1){
              this.inversion.capitaliza = "Si capitaliza intereses"
            }
            if(this.inversion.capitalizacion == 2){
              this.inversion.capitaliza = "Retiro mensual de los intereses"
            }
            if(this.inversion.capitalizacion == 3){
              this.inversion.capitaliza = "No capitaliza (retira al final)"
            }
            //Obtener tasa de interés mensual y la de retención
            var interes = this.inversion.tasa_interes/12
            this.inversion.tasa_interes_mensual = Math.round((interes + Number.EPSILON) * 100)/100;
            this.inversion.tasa_interes_mensual = Math.round((interes + Number.EPSILON) * 100)/100;
            var retencion = this.inversion.tasa_retencion/12;
            this.inversion.tasa_retencion_mensual = Math.round((retencion + Number.EPSILON) * 100)/100;
  
            //console.log("Inversiones", this.inversiones_fondeador);
            if(this.inversion.tipo_producto == "ahorrador"){
              console.log("Entro al if ahorrador");
              this.esAhorrador = true;
              //Variables
              this.inversion.mes_numero = 0;
              this.inversion.periodo_dias = 0;
              this.inversion.aportacion = 0;
              this.inversion.capital = 0;
              //this.inversion.rendimiento = 0;
              this.inversion.interes_generado = 0;
              //Valor del IVA de la BD
              this.inversion.iva = (this.inversion.iva/100);
              this.inversion.interes_acumulado = 0;
              this.inversion.saldo_final = 0;
              this.numMeses = this.inversion.plazo/this.inversion.periodicidad;
              //Saber si ya finalizó el esquema
              // Ver que esta dando esta validación //
              let fecha_temp_fin = new Date(this.inversion.fecha_fin_inversion).toISOString();
              let fecha_fin = fecha_temp_fin.split("T")[0];
              console.log(fecha_fin);
              console.log(this.fecha_actual);
              console.log("Fin: ", fecha_fin);
              if(this.fecha_actual >= fecha_fin){
                this.finEsquemaAhorro = true;
                console.log("El día coincide");
              }else{
                this.finEsquemaAhorro = false;
                console.log("El día no coincide");
              }
              //Calcular días restantes
              //let fecha_hoy = new Date("2022-12-01").getTime();
              let fecha_hoy = new Date(this.fecha_actual).getTime();
              let fecha_termino_inversion = new Date(this.inversion.fecha_fin_inversion).getTime();
              let diferencia = fecha_termino_inversion - fecha_hoy;
              this.dias_restantes = Math.round(diferencia/(1000*60*60*24));
              //Copiamos el json al nuevo arreglo
              for (let i = 0; i <= this.numMeses; i++) {
                this.inversiones_fondeador.push(Object.assign({} , this.inversion));
              }
              this.calcularNuevaTablaAhorradores();
  
            }else if(this.inversion.tipo_producto == "inversionista"){
              //Revisamos si capitaliza o no capitaliza
              if(this.inversion.capitalizacion == 1 || this.inversion.capitalizacion == 3){
                let fecha_temp_fin = new Date(this.inversion.fecha_fin_inversion).toISOString();
                let fecha_fin = fecha_temp_fin.split("T")[0];
                // console.log("Fin: ", new Date(fecha_fin));
                // console.log("actual: ", new Date(this.fecha_actual));
                if(new Date(fecha_fin) <= new Date(this.fecha_actual)){
                  this.isRetiroFinal = true;
                  console.log("Pasamos la fecha para el retiro final");
                }else{
                  this.isRetiroFinal = false;
                  console.log("El dia no coincide");
                }
              }
              //Obtenemos dias restantes
              //let fecha_hoy = new Date("2022-12-01").getTime();
              let fecha_hoy = new Date(this.fecha_actual).getTime();
              let fecha_termino_inversion = new Date(this.inversion.fecha_fin_inversion).getTime();
              let diferencia = fecha_termino_inversion - fecha_hoy;
              this.dias_restantes = Math.round(diferencia/(1000*60*60*24));
  
              this.esAhorrador = false;
              this.inversion.dia_pagos = fechaPago;
              this.inversion.total_inversion = this.inversion.monto;
              //this.inversion.pago_interes = (this.inversion.total_inversion * this.inversion.tasa_interes_mensual)/100;
              this.inversion.tasa_interes_diaria = ((this.inversion.tasa_interes/100)/360);
              this.inversion.tasa_retencion_diaria = ((this.inversion.tasa_retencion/100));
              this.inversion.pago_interes = (this.inversion.tasa_interes_diaria * (this.inversion.total_inversion * 30));
              this.numMeses = this.inversion.plazo/30;
              //Llenamos el arreglo de inversiones
              for (let i = 0; i <= this.numMeses; i++) {
                this.inversiones_fondeador.push(Object.assign({} , this.inversion));
              }
              resolve("OK");
              //Iniciamos cálculos en la tabla
              // this.calcularTablaInversion();
            }
            //this.esquemaCompletado();
            this.isLoading = false;
          }
  
        }, error =>
        {
          // se resuelve error 403 y 500
          this.isLoading = false;
          this.helperService.httpGlobalError(error);
  
          if(error.status == 400) {
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
          reject("ERROR");
        }
      );

    });
  }

  public incrementarInversion(){
    const dialogRef = this.dialog.open(IncrementarInversionModalComponent,{
      data: {inversiones: this.inversion, saldo: this.inversion.saldo_disponible},
      height: 'auto',
      width: 'auto',
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result.incremento){
        console.log("Incremento agregado: ", result.datosIncremento);
        //let incremento_inversion = result.datosIncremento;
        setTimeout(() => {window.location.reload()},3000);
      }
    });
  }

  public retirarFondos(){
    const dialogRef = this.dialog.open(DevolucionesInversionModalComponent,{
      data: {inversiones: this.inversion, total_inversion:  this.total_inversion, intereses: this.total_neto, capital: this.total_aportaciones, intereses_desp_impuestos: this.total_despues_impuestos },
      height: 'auto',
      width: 'auto',
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result.devolucion){
        console.log("Retiro realizado: ", result.datosRetiro);
        //let incremento_inversion = result.datosIncremento;
        setTimeout(() => {window.location.reload()},3000);
      }
    });
  }

  //Agrega nuevos pagos
  public nuevoPago(){
    //Abrimos el modal de pagos
    const dialogRef = this.dialog.open(PagosInversionModalComponent,{
      data: {inversiones: this.inversiones_fondeador, idEsquema: this.inversionId, idFondeador: this.fondeadorID, saldo: this.inversion.saldo_disponible, intereses: this.total_intereses, pago_final: this.isRetiroFinal, limites:this.pagos_de_ciclos},
      height: 'auto',
      width: '30vw',
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result.pagado){
        console.log("Pago realizado: ", result.datos_pago);
        setTimeout(() => {
          window.location.reload();
        }, 3000);
        // this.obtInversionId(this.inversionId);
        // this.obtenerPagosInversion();
      }
    });
  }

  public nuevoPagoFinal(){
    //Abrimos el modal de pagos
    // console.log("VER LOS INTERESES:",this.inversiones_fondeador)
    var nuevo_total=0;
    for (let i = 0; i < this.inversiones_fondeador.length; i++){
      nuevo_total += this.inversiones_fondeador[i].pago_interes
    }
    console.log(nuevo_total)
    const dialogRef = this.dialog.open(PagosInversionModalComponent,{
      data: {inversiones: this.inversiones_fondeador, idEsquema: this.inversionId, idFondeador: this.fondeadorID, saldo: this.inversion.saldo_disponible, intereses: nuevo_total, pago_final: true, limites:this.pagos_de_ciclos},
      height: 'auto',
      width: '30vw',
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result.pagado){
        console.log("Pago realizado: ", result.datos_pago);
        setTimeout(() => {
          window.location.reload();
        }, 3000);
        // this.obtInversionId(this.inversionId);
        // this.obtenerPagosInversion();
      }
    });
  }

  public async calcularTablaInversion():Promise<any>{
    return new Promise((resolve, reject)=>{
      //Para calcular fechas
      this.fechaTemp = new Date(this.inversiones_fondeador[0].fecha_inicio_inversion.replace(/-/g, '\/'));
      this.fechaTemp = this.fechaTemp.toISOString();
      this.fechaTemp = this.fechaTemp.split("T")[0];
      //Asignamos las fechas de pago
      console.log("Inicio de calculos")
      console.log(this.inversiones_fondeador)
      for (let i = 0; i <= this.numMeses; i++) {
        //this.inversiones_fondeador[i].fecha_pago = (anio+"-"+mes+"-"+dia);
        this.inversiones_fondeador[i].pago_despues_impuestos = 0;
        this.inversiones_fondeador[i].pago_realizado = "";
        this.inversiones_fondeador[i].estatus_pago = "";
        //this.inversiones_fondeador[i].monto_incremento = 0;
        //Verificamos si retiene impuestos
        if(this.inversion.retencion_impuestos == "si"){
          //Si la inversión si capitaliza intereses y retiene impuestos
          if(this.inversion.capitalizacion == 1){
            //SI CAPITALIZA
            //No acumula, si capitaliza y retira al final
            let monto_desp_impuestos = 0;
            if(i == 0){
              //Fecha inicial
              this.inversiones_fondeador[i].fecha_pago = this.fechaTemp;
              //monto_desp_impuestos = this.inversiones_fondeador[i].pago_interes - (this.inversiones_fondeador[i].pago_interes * this.inversiones_fondeador[i].tasa_retencion_mensual)/100;
              this.inversiones_fondeador[i].total_inversion = this.inversion.monto;
              this.inversiones_fondeador[i].pago_interes = 0;
            }else{
              //Fechas siguientes
              this.fechaTemp = new Date(this.inversiones_fondeador[i-1].fecha_pago);
              this.fechaTemp.setDate(this.fechaTemp.getDate() + 30);
              this.fechaTemp = this.fechaTemp.toISOString();
              this.fechaTemp = this.fechaTemp.split("T")[0];
              this.inversiones_fondeador[i].fecha_pago = this.fechaTemp;
              if(i == 1){
                //Calculos
                this.inversiones_fondeador[i].total_inversion = this.inversiones_fondeador[i].monto;
              }else{
                this.inversiones_fondeador[i].total_inversion = this.inversiones_fondeador[i-1].total_inversion  + this.inversiones_fondeador[i-1].pago_despues_impuestos;
              }
              //Calculos
              this.inversiones_fondeador[i].pago_interes = ( this.inversiones_fondeador[i].tasa_interes_diaria * (this.inversiones_fondeador[i].total_inversion * 30));
              //this.inversiones_fondeador[i].pago_interes = (this.inversiones_fondeador[i].total_inversion * this.inversiones_fondeador[i].tasa_interes_mensual)/100;
              monto_desp_impuestos = this.inversiones_fondeador[i].pago_interes - ((this.inversiones_fondeador[i].tasa_retencion_diaria) * this.inversiones_fondeador[i].pago_interes);
              //monto_desp_impuestos = this.inversiones_fondeador[i].pago_interes - (this.inversiones_fondeador[i].pago_interes * this.inversiones_fondeador[i].tasa_retencion_mensual)/100;
              //Nueva columna para pago después de impuestos
              this.inversiones_fondeador[i].pago_despues_impuestos = monto_desp_impuestos;
            }
  
          }else if(this.inversion.capitalizacion == 2){
            //No acumula, no capitaliza y retira mensual
            if(i == 0){
              this.inversiones_fondeador[i].fecha_pago = this.fechaTemp;
              this.inversiones_fondeador[i].total_inversion = this.inversion.monto;
              this.inversiones_fondeador[i].pago_interes = 0;
            }else{
              //Fechas siguientes
              this.fechaTemp = new Date(this.inversiones_fondeador[i-1].fecha_pago);
              this.fechaTemp.setDate(this.fechaTemp.getDate() + 30);
              this.fechaTemp = this.fechaTemp.toISOString();
              this.fechaTemp = this.fechaTemp.split("T")[0];
              this.inversiones_fondeador[i].fecha_pago = this.fechaTemp;
               if(i == 1){
                //Calculos
                this.inversiones_fondeador[i].total_inversion = this.inversiones_fondeador[i].monto;
              }else{
                this.inversiones_fondeador[i].total_inversion = this.inversiones_fondeador[i-1].total_inversion;
              }
              //this.inversiones_fondeador[i].total_inversion = (this.inversiones_fondeador[i-1].total_inversion + this.inversiones_fondeador[i].monto + this.inversiones_fondeador[i-1].pago_despues_impuestos);
              //this.inversiones_fondeador[i].total_inversion = this.inversiones_fondeador[i].monto;
              this.inversiones_fondeador[i].pago_interes = ( this.inversiones_fondeador[i].tasa_interes_diaria * (this.inversiones_fondeador[i].total_inversion * 30));
              let monto_desp_impuestos = this.inversiones_fondeador[i].pago_interes - ((this.inversiones_fondeador[i].tasa_retencion_diaria) * this.inversiones_fondeador[i].pago_interes);
              //monto_desp_impuestos = this.inversiones_fondeador[i].pago_interes - (this.inversiones_fondeador[i].pago_interes * this.inversiones_fondeador[i].tasa_retencion_mensual)/100;
              //Nueva columna para pago después de impuestos
              this.inversiones_fondeador[i].pago_despues_impuestos = monto_desp_impuestos;
            }
  
            //let monto_desp_impuestos = this.inversiones_fondeador[i].pago_interes - ((this.inversiones_fondeador[i].tasa_retencion_diaria * 30) * this.inversiones_fondeador[i].pago_interes);
            //Nueva columna para pago después de impuestos
            //this.inversiones_fondeador[i].pago_despues_impuestos = monto_desp_impuestos;
          }else if(this.inversion.capitalizacion == 3){
            //NO CAPITALIZA
            //Acumula, no capitaliza y retira al final
            if(i == 0){
              this.inversiones_fondeador[i].fecha_pago = this.fechaTemp;
              this.inversiones_fondeador[i].total_inversion = this.inversion.monto;
              this.inversiones_fondeador[i].pago_interes = 0;
              //monto_desp_impuestos = this.inversiones_fondeador[i].pago_interes - (this.inversiones_fondeador[i].pago_interes * this.inversiones_fondeador[i].tasa_retencion_mensual)/100;
              // let monto_desp_impuestos = this.inversiones_fondeador[i].pago_interes - ((this.inversiones_fondeador[i].tasa_retencion_diaria * 30) * this.inversiones_fondeador[i].pago_interes);
              // this.inversiones_fondeador[i].pago_despues_impuestos = monto_desp_impuestos;
            }else{
              //Fechas siguientes
              this.fechaTemp = new Date(this.inversiones_fondeador[i-1].fecha_pago);
              this.fechaTemp.setDate(this.fechaTemp.getDate() + 30);
              this.fechaTemp = this.fechaTemp.toISOString();
              this.fechaTemp = this.fechaTemp.split("T")[0];
              this.inversiones_fondeador[i].fecha_pago = this.fechaTemp;
               if(i == 1){
                //Calculos
                this.inversiones_fondeador[i].total_inversion = this.inversiones_fondeador[i].monto;
              }else{
                this.inversiones_fondeador[i].total_inversion = this.inversiones_fondeador[i-1].total_inversion  + this.inversiones_fondeador[i-1].pago_despues_impuestos;
              }
              //this.inversiones_fondeador[i].total_inversion = (this.inversiones_fondeador[i-1].total_inversion + this.inversiones_fondeador[i].monto + this.inversiones_fondeador[i-1].pago_despues_impuestos);
              //this.inversiones_fondeador[i].total_inversion = this.inversiones_fondeador[i].monto;
              this.inversiones_fondeador[i].pago_interes = ( this.inversiones_fondeador[i].tasa_interes_diaria * (this.inversiones_fondeador[i].total_inversion * 30));
              let monto_desp_impuestos = this.inversiones_fondeador[i].pago_interes - ((this.inversiones_fondeador[i].tasa_retencion_diaria) * this.inversiones_fondeador[i].pago_interes);
              //monto_desp_impuestos = this.inversiones_fondeador[i].pago_interes - (this.inversiones_fondeador[i].pago_interes * this.inversiones_fondeador[i].tasa_retencion_mensual)/100;
              //Nueva columna para pago después de impuestos
              this.inversiones_fondeador[i].pago_despues_impuestos = monto_desp_impuestos;
            }
          }
        }else{
          //NO RETIENE IMPUESTOS
          //Si la inversión si capitaliza intereses y no retiene impuestos
          if(this.inversion.capitalizacion == 1){
            if(i > 0){
              //Fechas siguientes
              this.fechaTemp = new Date(this.inversiones_fondeador[i-1].fecha_pago);
              this.fechaTemp.setDate(this.fechaTemp.getDate() + 30);
              this.fechaTemp = this.fechaTemp.toISOString();
              this.fechaTemp = this.fechaTemp.split("T")[0];
              this.inversiones_fondeador[i].fecha_pago = this.fechaTemp;
  
              if(i == 1){
                this.inversiones_fondeador[i].total_inversion = this.inversiones_fondeador[i].monto;
                this.inversiones_fondeador[i].pago_interes = (this.inversiones_fondeador[i].total_inversion * this.inversiones_fondeador[i].tasa_interes_diaria)*30;
              }else{
                this.inversiones_fondeador[i].total_inversion = this.inversiones_fondeador[i-1].total_inversion  + this.inversiones_fondeador[i-1].pago_interes;
                this.inversiones_fondeador[i].pago_interes = (this.inversiones_fondeador[i].total_inversion * this.inversiones_fondeador[i].tasa_interes_diaria)*30;
              }
  
  
            }else if(i == 0){
              this.inversiones_fondeador[i].fecha_pago = this.fechaTemp;
              this.inversiones_fondeador[i].total_inversion = this.inversion.monto;
              this.inversiones_fondeador[i].pago_interes = 0;
            }
          }else if(this.inversion.capitalizacion == 2){
            //No acumula, no capitaliza y retira mensual
            if(i == 0){
              this.inversiones_fondeador[i].fecha_pago = this.fechaTemp;
              this.inversiones_fondeador[i].total_inversion = 0;
              this.inversiones_fondeador[i].pago_interes = 0;
            }else{
              //Fechas siguientes
              this.fechaTemp = new Date(this.inversiones_fondeador[i-1].fecha_pago);
              this.fechaTemp.setDate(this.fechaTemp.getDate() + 30);
              this.fechaTemp = this.fechaTemp.toISOString();
              this.fechaTemp = this.fechaTemp.split("T")[0];
              this.inversiones_fondeador[i].fecha_pago = this.fechaTemp;
               if(i == 1){
                //Calculos
                this.inversiones_fondeador[i].total_inversion = this.inversiones_fondeador[i].monto;
              }else{
                this.inversiones_fondeador[i].total_inversion = this.inversiones_fondeador[i-1].total_inversion;
              }
              //this.inversiones_fondeador[i].total_inversion = (this.inversiones_fondeador[i-1].total_inversion + this.inversiones_fondeador[i].monto + this.inversiones_fondeador[i-1].pago_despues_impuestos);
              //this.inversiones_fondeador[i].total_inversion = this.inversiones_fondeador[i].monto;
              this.inversiones_fondeador[i].pago_interes = ( this.inversiones_fondeador[i].tasa_interes_diaria * (this.inversiones_fondeador[i].total_inversion * 30));
  
            }
  
          }else if(this.inversion.capitalizacion == 3){
            if(i > 0){
              //Fechas siguientes
              this.fechaTemp = new Date(this.inversiones_fondeador[i-1].fecha_pago);
              this.fechaTemp.setDate(this.fechaTemp.getDate() + 30);
              this.fechaTemp = this.fechaTemp.toISOString();
              this.fechaTemp = this.fechaTemp.split("T")[0];
              this.inversiones_fondeador[i].fecha_pago = this.fechaTemp;
              //this.inversiones_fondeador[i].total_inversion = ( this.inversiones_fondeador[i-1].total_inversion + this.inversiones_fondeador[i].monto );
              this.inversiones_fondeador[i].total_inversion = this.inversiones_fondeador[i].monto;
              //this.inversiones_fondeador[i].total_inversion = ( this.inversiones_fondeador[i-1].total_inversion + this.inversiones_fondeador[i].monto );
              this.inversiones_fondeador[i].pago_interes = ( this.inversiones_fondeador[i].tasa_interes_diaria * (this.inversiones_fondeador[i].total_inversion * 30));
            }else{
              this.inversiones_fondeador[i].fecha_pago = this.fechaTemp;
              this.inversiones_fondeador[i].total_inversion = this.inversion.monto;
              this.inversiones_fondeador[i].pago_interes = 0;
            }
          }
        }
      }
      resolve(true);
    });
  }
  
  public delay(time) {
    return new Promise(resolve => setTimeout(resolve, time));
  }

  public calcularIncrementos(){
    //Revisa si tiene incrementos para que haga la modificacion de la tabla
    console.log("Lista --- ", this.inversiones_fondeador);

    if(this.lista_incrementos.length > 0){
      //Comparar las fechas de pago con la fecha del incremento de inversión
      for (let index = 0; index < this.lista_incrementos.length; index++) {
        const incremento = this.lista_incrementos[index];
        const fechaIncremento = new Date(incremento.fecha_incremento_inversion).toISOString();
        for (let j = 0; j < this.inversiones_fondeador.length; j++) {
          const fechaPago = new Date(this.inversiones_fondeador[j].fecha_pago).toISOString();
          if( j < this.inversiones_fondeador.length-1){
            console.log("J: ",j);
            if (j==0){
              console.log("ROW---", this.inversiones_fondeador[j])
              this.inversiones_fondeador[j].total_inversion = this.inversiones_fondeador[j].monto;
            }
            if(this.inversiones_fondeador[j].fecha_pago != ""){
              const fechaPagoSig = new Date(this.inversiones_fondeador[j+1].fecha_pago).toISOString();
              if(fechaIncremento >= fechaPago && fechaIncremento < fechaPagoSig){
                //Agregamos nuevos valores a la tabla
                let jsonTemp = (Object.assign({} , this.inversiones_fondeador[j]));
                console.log("Log JsonTemp: ", jsonTemp);

                jsonTemp.monto_incremento = incremento.monto_incremento;
                jsonTemp.fecha_incremento_inversion = incremento.fecha_incremento_inversion;

                //Revisar si retiene impuestos
                let total_inversion = 0;
                let pago_intereses = 0;
                if(this.inversion.retencion_impuestos == "si"){
                  //Si la inversión si capitaliza intereses y retiene impuestos
                  jsonTemp.total_inversion = total_inversion;

                  let monto_desp_impuestos = 0;
                  if(this.inversion.capitalizacion == 1){
                    //monto_desp_impuestos = jsonTemp.pago_interes - ((jsonTemp.pago_interes * jsonTemp.tasa_retencion_mensual)/100);
                    monto_desp_impuestos = jsonTemp.pago_interes - ((jsonTemp.tasa_retencion_diaria) * jsonTemp.pago_interes);
                    console.log("EnInc---: ",monto_desp_impuestos);
                    jsonTemp.pago_despues_impuestos = monto_desp_impuestos;

                    total_inversion = this.inversiones_fondeador[j].total_inversion + jsonTemp.monto_incremento + this.inversiones_fondeador[j].pago_despues_impuestos;
                    jsonTemp.total_inversion = total_inversion;
                  }else if(this.inversion.capitalizacion == 2){
                    total_inversion = this.inversiones_fondeador[j].total_inversion + jsonTemp.monto_incremento;
                    jsonTemp.total_inversion = total_inversion;
                  }else if(this.inversion.capitalizacion == 3){
                    total_inversion = this.inversiones_fondeador[j].total_inversion + jsonTemp.monto_incremento + this.inversiones_fondeador[j].monto;
                    jsonTemp.total_inversion = total_inversion;
                  }
                }else{
                  //Revisa si capitaliza intereses
                  if(this.inversion.capitalizacion == 1){
                    //let jsonAnt = (Object.assign({} , this.inversiones_fondeador[j]));
                    total_inversion = this.inversiones_fondeador[j].total_inversion + jsonTemp.monto_incremento + this.inversiones_fondeador[j].pago_interes;
                    jsonTemp.total_inversion = total_inversion;
                  }else if(this.inversion.capitalizacion == 2){
                    console.log("Tabla que se esta recvisando")
                    console.log(jsonTemp.total_inversion)
                    console.log("Vamos a agregarle el incremento a "+this.inversiones_fondeador[j].total_inversion);
                    total_inversion = this.inversiones_fondeador[j].total_inversion + jsonTemp.monto_incremento;
                    jsonTemp.total_inversion = total_inversion;
                  }else if(this.inversion.capitalizacion == 3){
                    total_inversion = this.inversiones_fondeador[j].total_inversion + jsonTemp.monto_incremento + this.inversiones_fondeador[j].monto;
                    jsonTemp.total_inversion = total_inversion;
                  }
                }
                pago_intereses = ((jsonTemp.total_inversion * 30) * jsonTemp.tasa_interes_diaria);
                jsonTemp.pago_interes = pago_intereses;
                //console.log("Intereses: ", pago_intereses);
                //jsonTemp.fecha_pago= "";
                jsonTemp.monto = "";

                this.inversiones_fondeador.splice(j+1,0,jsonTemp);

                if(this.inversion.capitalizacion == 2){
                  for (let k = j+1; k < this.inversiones_fondeador.length; k++) {
                    this.inversiones_fondeador[k].total_inversion = total_inversion;
                    this.inversiones_fondeador[k].pago_interes = pago_intereses;
                  }
                }
                console.log(this.inversiones_fondeador);
                break;
              }
            }

          }
          if( j === this.inversiones_fondeador.length-1){
            if( index === this.lista_incrementos.length-1){
              // console.log("FIncremento: ", fechaIncremento);
              // console.log("Pago: ",fechaPago);
              if(fechaIncremento >= fechaPago){
                //Agregamos nuevos valores a la tabla
                let jsonTemp = (Object.assign({} , this.inversiones_fondeador[j]));
                jsonTemp.monto_incremento = incremento.monto_incremento;
                jsonTemp.fecha_incremento_inversion = incremento.fecha_incremento_inversion;

                //Agregamos al arreglo los cambios de inversión
                let total_inversion = jsonTemp.total_inversion + jsonTemp.monto_incremento;
                jsonTemp.total_inversion = total_inversion;

                let pago_intereses = ((jsonTemp.total_inversion * 30) * jsonTemp.tasa_interes_diaria);
                //let pago_intereses = (jsonTemp.total_inversion * jsonTemp.tasa_interes_mensual)/100;
                jsonTemp.pago_interes = pago_intereses;
                //console.log("Intereses: ", pago_intereses);

                //jsonTemp.fecha_pago= "";
                jsonTemp.monto = "";
                this.inversiones_fondeador.push(jsonTemp);
                break;
              }

            }
          }

        }
      }
      //Primero se actualizan las cantidades
      this.actualizarCantidades();
      //Después se aplican devoluciones
      this.obtenerPagosInversion();
    }else{
      this.obtenerPagosInversion();
    }
  }

  public actualizarCantidades(){

    if(this.inversion.retencion_impuestos == "si"){
      for (let i = 1; i < this.inversiones_fondeador.length; i++) {
        //Si la inversión si capitaliza intereses y retiene impuestos
        if(this.inversion.capitalizacion == 1){
          if(this.inversiones_fondeador[i].monto_incremento){
            this.inversiones_fondeador[i].total_inversion = this.inversiones_fondeador[i-1].total_inversion  + this.inversiones_fondeador[i-1].pago_despues_impuestos + this.inversiones_fondeador[i].monto_incremento;
          }else{
            this.inversiones_fondeador[i].total_inversion = this.inversiones_fondeador[i-1].total_inversion  + this.inversiones_fondeador[i-1].pago_despues_impuestos;
          }
          this.inversiones_fondeador[i].pago_interes = ((this.inversiones_fondeador[i].total_inversion * 30) * this.inversiones_fondeador[i].tasa_interes_diaria);
          //this.inversiones_fondeador[i].pago_interes = (this.inversiones_fondeador[i].total_inversion * this.inversiones_fondeador[i].tasa_interes_mensual)/100;
          this.inversiones_fondeador[i].pago_despues_impuestos = this.inversiones_fondeador[i].pago_interes - ((this.inversiones_fondeador[i].pago_interes * 30) * this.inversiones_fondeador[i].tasa_retencion_diaria);
        }else if(this.inversion.capitalizacion == 2){
          if(this.inversiones_fondeador[i].monto_incremento){
            this.inversiones_fondeador[i].total_inversion = this.inversiones_fondeador[i-1].total_inversion  + this.inversiones_fondeador[i-1].pago_despues_impuestos + this.inversiones_fondeador[i].monto_incremento;
          }else{
            this.inversiones_fondeador[i].total_inversion = this.inversiones_fondeador[i-1].total_inversion  + this.inversiones_fondeador[i-1].pago_despues_impuestos;
          }
          this.inversiones_fondeador[i].pago_interes = ((this.inversiones_fondeador[i].total_inversion * 30) * this.inversiones_fondeador[i].tasa_interes_diaria);
          //this.inversiones_fondeador[i].pago_interes = (this.inversiones_fondeador[i].total_inversion * this.inversiones_fondeador[i].tasa_interes_mensual)/100;
          this.inversiones_fondeador[i].pago_despues_impuestos = this.inversiones_fondeador[i].pago_interes - ((this.inversiones_fondeador[i].pago_interes * 30) * this.inversiones_fondeador[i].tasa_retencion_diaria);
        }else if(this.inversion.capitalizacion == 3){
          if(this.inversiones_fondeador[i].monto_incremento){
            this.inversiones_fondeador[i].total_inversion = this.inversiones_fondeador[i-1].total_inversion  + this.inversiones_fondeador[i-1].pago_despues_impuestos + this.inversiones_fondeador[i].monto_incremento + this.inversion.monto;
          }else{
            this.inversiones_fondeador[i].total_inversion = this.inversiones_fondeador[i-1].total_inversion  + this.inversiones_fondeador[i-1].pago_despues_impuestos + this.inversion.monto;
          }
          this.inversiones_fondeador[i].pago_interes = ((this.inversiones_fondeador[i].total_inversion * 30) * this.inversiones_fondeador[i].tasa_interes_diaria);
          //this.inversiones_fondeador[i].pago_interes = (this.inversiones_fondeador[i].total_inversion * this.inversiones_fondeador[i].tasa_interes_mensual)/100;
          this.inversiones_fondeador[i].pago_despues_impuestos = this.inversiones_fondeador[i].pago_interes - ((this.inversiones_fondeador[i].pago_interes * 30) * this.inversiones_fondeador[i].tasa_retencion_diaria);
        }

      }
    }else{
      for (let i = 1; i < this.inversiones_fondeador.length; i++) {
        //Si la inversión si capitaliza intereses
        if(this.inversion.capitalizacion == 1){
          //SI CAPITALIZA
          if(this.inversiones_fondeador[i].monto_incremento){
            this.inversiones_fondeador[i].total_inversion = this.inversiones_fondeador[i-1].total_inversion  + this.inversiones_fondeador[i-1].pago_interes + this.inversiones_fondeador[i].monto_incremento;
          }else{
            this.inversiones_fondeador[i].total_inversion = this.inversiones_fondeador[i-1].total_inversion  + this.inversiones_fondeador[i-1].pago_interes;
          }
          this.inversiones_fondeador[i].pago_interes = ((this.inversiones_fondeador[i].total_inversion * 30) * this.inversiones_fondeador[i].tasa_interes_diaria);
          this.inversiones_fondeador[i].pago_despues_impuestos = 0;

        }else if(this.inversion.capitalizacion == 2){
          //RETIRA MENSUAL
          if(this.inversiones_fondeador[i].monto_incremento){
            if (i-1==0){
              this.inversiones_fondeador[i].total_inversion = this.inversiones_fondeador[i-1].monto + this.inversiones_fondeador[i].monto_incremento;
            }else{
              this.inversiones_fondeador[i].total_inversion = this.inversiones_fondeador[i-1].total_inversion + this.inversiones_fondeador[i].monto_incremento;
            }
          }else{
            this.inversiones_fondeador[i].total_inversion = this.inversiones_fondeador[i-1].total_inversion;
          }
          this.inversiones_fondeador[i].pago_interes = ((this.inversiones_fondeador[i].total_inversion * 30) * this.inversiones_fondeador[i].tasa_interes_diaria);
          this.inversiones_fondeador[i].pago_despues_impuestos = 0;
        }else if(this.inversion.capitalizacion == 3){
          //NO CAPITALIZA
          if(this.inversiones_fondeador[i].monto_incremento){
            this.inversiones_fondeador[i].total_inversion = this.inversiones_fondeador[i-1].total_inversion + this.inversiones_fondeador[i].monto_incremento + this.inversion.monto;
          }else{
            this.inversiones_fondeador[i].total_inversion = this.inversiones_fondeador[i-1].total_inversion  + this.inversion.monto;
          }
          this.inversiones_fondeador[i].pago_interes = ((this.inversiones_fondeador[i].total_inversion * 30) * this.inversiones_fondeador[i].tasa_interes_diaria);
          this.inversiones_fondeador[i].pago_despues_impuestos = 0;

        }
      }
    }
    console.log("Tabla AC: ", this.inversiones_fondeador);
  }

  public limpiarCamposTabla(){
    for (let i = 0; i < this.inversiones_fondeador.length; i++) {
      if(this.inversiones_fondeador[i].monto == ""){
        this.inversiones_fondeador[i].fecha_pago="";
        this.inversiones_fondeador[i].monto="";
        this.inversiones_fondeador[i].tasa_interes_mensual="";

      }
      if(i == this.inversiones_fondeador.length-1){
        this.total = this.inversiones_fondeador[i].total_inversion;
      }
    }
  }

  public calcularTablaConDevoluciones(){
    //Solo se realiza si se tienen devoluciones
    if(this.lista_devoluciones.length > 0){
      this.lista_devoluciones.forEach((devolucion, index) => {
        const fechaDevolucion = new Date(devolucion.fecha_devolucion_inversion).toISOString();
        for (let j = 0; j < this.inversiones_fondeador.length; j++) {
          const fechaPago = new Date(this.inversiones_fondeador[j].fecha_pago).toISOString();
          if( j < this.inversiones_fondeador.length-1){
            //console.log("J: ",j);
            if(this.inversiones_fondeador[j].fecha_pago != ""){
              const fechaPagoSig = new Date(this.inversiones_fondeador[j+1].fecha_pago).toISOString();
              if(fechaDevolucion >= fechaPago && fechaDevolucion < fechaPagoSig){
                //Agregamos nuevos valores a la tabla
                let jsonTempDev = (Object.assign({} , this.inversiones_fondeador[j]));

                jsonTempDev.idRetiro = devolucion.idDevolucionInversion;
                jsonTempDev.tipo_retiro = devolucion.tipo_retiro;
                jsonTempDev.monto_retiro = devolucion.monto_retiro;
                jsonTempDev.fecha_devolucion_inversion = devolucion.fecha_devolucion_inversion;

                //Agregamos al arreglo los cambios de inversión
                //let total_inversion = jsonTempDev.total_inversion - jsonTempDev.monto_retiro;
                let total_inversion = 0;
                let pago_intereses = 0;
                //Revisar si retiene impuestos
                if(this.inversion.retencion_impuestos == "si"){
                  let monto_desp_impuestos = 0;
                  if(this.inversion.capitalizacion == 1){
                    //let jsonAnt = (Object.assign({} , this.inversiones_fondeador[j]));
                    monto_desp_impuestos = jsonTempDev.pago_interes - ((jsonTempDev.pago_interes * 30 ) * jsonTempDev.tasa_retencion_diaria);
                    //monto_desp_impuestos = jsonTempDev.pago_interes - ((jsonTempDev.pago_interes * jsonTempDev.tasa_retencion_mensual)/100);
                    jsonTempDev.pago_despues_impuestos = monto_desp_impuestos;

                    total_inversion = this.inversiones_fondeador[j].total_inversion - jsonTempDev.monto_retiro + this.inversiones_fondeador[j].pago_despues_impuestos;
                    jsonTempDev.total_inversion = total_inversion;
                  }else if (this.inversion.capitalizacion == 2){
                    total_inversion = (this.inversiones_fondeador[j].total_inversion - jsonTempDev.monto_retiro) + this.inversiones_fondeador[j].pago_despues_impuestos;
                    jsonTempDev.total_inversion = total_inversion;
                  }else if(this.inversion.capitalizacion == 3){
                    total_inversion = (this.inversiones_fondeador[j].total_inversion - jsonTempDev.monto_retiro) + this.inversion.monto + this.inversiones_fondeador[j].pago_despues_impuestos;
                    jsonTempDev.total_inversion = total_inversion;
                  }
                }else{
                  if(this.inversion.capitalizacion == 1){
                    total_inversion = this.inversiones_fondeador[j].total_inversion - jsonTempDev.monto_retiro + this.inversiones_fondeador[j].pago_interes;
                    jsonTempDev.total_inversion = total_inversion;
                  }else if(this.inversion.capitalizacion == 2){
                    total_inversion = this.inversiones_fondeador[j].total_inversion - jsonTempDev.monto_retiro;
                    jsonTempDev.total_inversion = total_inversion;
                  }else if(this.inversion.capitalizacion == 3){
                    total_inversion = (this.inversiones_fondeador[j].total_inversion - jsonTempDev.monto_retiro) + this.inversion.monto;
                    jsonTempDev.total_inversion = total_inversion;
                  }
                }
                //jsonTempDev.total_inversion = total_inversion;

                pago_intereses = ((jsonTempDev.total_inversion * 30) * jsonTempDev.tasa_interes_diaria);
                jsonTempDev.pago_interes = pago_intereses;
                //console.log("Intereses: ", pago_intereses);
                //jsonTemp.fecha_pago= "";
                jsonTempDev.monto = "";
                delete jsonTempDev["monto_incremento"];
                //jsonTempDev.monto_incremento="";
                jsonTempDev.fecha_incremento_inversion ="";

                this.inversiones_fondeador.splice(j+1,0,jsonTempDev);

                if(this.inversiones_fondeador[j].capitalizacion == 2){
                  for (let k = j+1; k < this.inversiones_fondeador.length; k++) {
                    this.inversiones_fondeador[k].total_inversion = total_inversion;
                    this.inversiones_fondeador[k].pago_interes = pago_intereses;
                  }
                }
                console.log(this.inversiones_fondeador);
                break;
              }
            }

          }
          if( j === this.inversiones_fondeador.length-1){
            if( index === this.lista_incrementos.length-1){
              // console.log("FIncremento: ", fechaIncremento);
              // console.log("Pago: ",fechaPago);
              if(fechaDevolucion >= fechaPago){
                //Agregamos nuevos valores a la tabla
                let jsonTempDev = (Object.assign({} , this.inversiones_fondeador[j]));
                jsonTempDev.idRetiro = devolucion.idDevolucionInversion;
                jsonTempDev.tipo_retiro = devolucion.tipo_retiro;
                jsonTempDev.monto_retiro = devolucion.monto_retiro;
                jsonTempDev.fecha_devolucion_inversion = devolucion.fecha_devolucion_inversion;

                //Agregamos al arreglo los cambios de inversión
                let total_inversion = jsonTempDev.total_inversion + jsonTempDev.monto_retiro;
                jsonTempDev.total_inversion = total_inversion;

                let pago_intereses = ((jsonTempDev.total_inversion * 30) * jsonTempDev.tasa_interes_diaria);
                jsonTempDev.pago_interes = pago_intereses;
                //console.log("Intereses: ", pago_intereses);

                //jsonTemp.fecha_pago= "";
                jsonTempDev.monto = "";
                delete jsonTempDev["monto_incremento"];
                //jsonTempDev.monto_incremento="";
                jsonTempDev.fecha_incremento_inversion ="";
                this.inversiones_fondeador.push(jsonTempDev);
                break;
              }

            }
          }

        }

      });
      //Primero se actualizan las cantidades
      //this.actualizarCantidades();
      //Después se aplican devoluciones
      this.actualizarConDevoluciones();
      // //setTimeout(() => {this.actualizarConDevoluciones()},3000);
      //this.limpiarCamposTabla();
      this.obtenerPagosInversion();
    }else{
      this.obtenerPagosInversion();
    }
  }

  public actualizarConDevoluciones(){
    // this.inversiones_fondeador[1].total_inversion =100
    if(this.inversion.retencion_impuestos == "si"){
      for (let i = 1; i < this.inversiones_fondeador.length; i++) {
        if (i == 1){
          this.inversiones_fondeador[i-1].total_inversion = this.inversiones_fondeador[i].total_inversion
        }
        //Si la inversión si capitaliza intereses y si retiene impuestos
        if(this.inversion.capitalizacion == 1){
          //SI CAPITALIZA
          if(this.inversiones_fondeador[i].monto_incremento){
            this.inversiones_fondeador[i].total_inversion = this.inversiones_fondeador[i-1].total_inversion  + this.inversiones_fondeador[i-1].pago_despues_impuestos + this.inversiones_fondeador[i].monto_incremento;
          }else if(this.inversiones_fondeador[i].monto_retiro){
            this.inversiones_fondeador[i].total_inversion = this.inversiones_fondeador[i-1].total_inversion  + this.inversiones_fondeador[i-1].pago_despues_impuestos - this.inversiones_fondeador[i].monto_retiro;
          }
          else{
            this.inversiones_fondeador[i].total_inversion = this.inversiones_fondeador[i-1].total_inversion  + this.inversiones_fondeador[i-1].pago_despues_impuestos;
          }
          this.inversiones_fondeador[i].pago_interes = ((this.inversiones_fondeador[i].total_inversion * 30) * this.inversiones_fondeador[i].tasa_interes_diaria);
          this.inversiones_fondeador[i].pago_despues_impuestos = this.inversiones_fondeador[i].pago_interes - ((this.inversiones_fondeador[i].pago_interes * 30) * this.inversiones_fondeador[i].tasa_retencion_diaria);
        }else if(this.inversion.capitalizacion == 2){
          //RETIRO MENSUAL
          if(this.inversiones_fondeador[i].monto_incremento){
            this.inversiones_fondeador[i].total_inversion = this.inversiones_fondeador[i-1].total_inversion + this.inversiones_fondeador[i].monto_incremento;
          }else if(this.inversiones_fondeador[i].monto_retiro){
            this.inversiones_fondeador[i].total_inversion = this.inversiones_fondeador[i-1].total_inversion - this.inversiones_fondeador[i].monto_retiro;
          }
          else{
            this.inversiones_fondeador[i].total_inversion = this.inversiones_fondeador[i-1].total_inversion  + this.inversiones_fondeador[i-1].pago_despues_impuestos;
          }
          this.inversiones_fondeador[i].pago_interes = ((this.inversiones_fondeador[i].total_inversion * 30) * this.inversiones_fondeador[i].tasa_interes_diaria);
          this.inversiones_fondeador[i].pago_despues_impuestos = this.inversiones_fondeador[i].pago_interes - ((this.inversiones_fondeador[i].pago_interes * 30) * this.inversiones_fondeador[i].tasa_retencion_diaria);
        }else if(this.inversion.capitalizacion == 3){
          //NO CAPITALIZA
          if(this.inversiones_fondeador[i].monto_incremento){
            this.inversiones_fondeador[i].total_inversion = this.inversiones_fondeador[i-1].total_inversion + this.inversiones_fondeador[i].monto_incremento + this.inversion.monto;
          }else if(this.inversiones_fondeador[i].monto_retiro){
            this.inversiones_fondeador[i].total_inversion = (this.inversiones_fondeador[i-1].total_inversion - this.inversiones_fondeador[i].monto_retiro) + this.inversion.monto;
          }
          else{
            this.inversiones_fondeador[i].total_inversion = this.inversiones_fondeador[i-1].total_inversion  + this.inversiones_fondeador[i-1].pago_despues_impuestos + this.inversion.monto;
          }
          this.inversiones_fondeador[i].pago_interes = ((this.inversiones_fondeador[i].total_inversion * 30) * this.inversiones_fondeador[i].tasa_interes_diaria);
          this.inversiones_fondeador[i].pago_despues_impuestos = this.inversiones_fondeador[i].pago_interes - ((this.inversiones_fondeador[i].pago_interes * 30) * this.inversiones_fondeador[i].tasa_retencion_diaria);
        }

      }
    }else{
      for (let i = 1; i < this.inversiones_fondeador.length; i++) {
        if (i == 1){
          this.inversiones_fondeador[i-1].total_inversion = this.inversiones_fondeador[i].total_inversion
        }
        //Si la inversión si capitaliza intereses
        if(this.inversiones_fondeador[i].capitalizacion == 1){
          //SI CAPITALIZA
          if(this.inversiones_fondeador[i].monto_incremento){
            this.inversiones_fondeador[i].total_inversion = this.inversiones_fondeador[i-1].total_inversion  + this.inversiones_fondeador[i-1].pago_interes + this.inversiones_fondeador[i].monto_incremento;
          }else if(this.inversiones_fondeador[i].monto_retiro){
            this.inversiones_fondeador[i].total_inversion = this.inversiones_fondeador[i-1].total_inversion  + this.inversiones_fondeador[i-1].pago_interes - this.inversiones_fondeador[i].monto_retiro;
          }
          else{
            this.inversiones_fondeador[i].total_inversion = this.inversiones_fondeador[i-1].total_inversion  + this.inversiones_fondeador[i-1].pago_interes;
          }
          this.inversiones_fondeador[i].pago_interes = ((this.inversiones_fondeador[i].total_inversion * 30) * this.inversiones_fondeador[i].tasa_interes_diaria);
          this.inversiones_fondeador[i].pago_despues_impuestos = 0;
        }else if(this.inversion.capitalizacion == 2){
          //RETIRO MENSUAL
          if(this.inversiones_fondeador[i].monto_incremento){
            this.inversiones_fondeador[i].total_inversion = this.inversiones_fondeador[i-1].total_inversion + this.inversiones_fondeador[i].monto_incremento;
          }else if(this.inversiones_fondeador[i].monto_retiro){
            this.inversiones_fondeador[i].total_inversion = this.inversiones_fondeador[i-1].total_inversion - this.inversiones_fondeador[i].monto_retiro;
          }
          else{
            this.inversiones_fondeador[i].total_inversion = this.inversiones_fondeador[i-1].total_inversion;
          }
          this.inversiones_fondeador[i].pago_interes = ((this.inversiones_fondeador[i].total_inversion * 30) * this.inversiones_fondeador[i].tasa_interes_diaria);
          this.inversiones_fondeador[i].pago_despues_impuestos = 0;
        }else if(this.inversion.capitalizacion == 3){
          //NO CAPITALIZA
          if(this.inversiones_fondeador[i].monto_incremento){
            this.inversiones_fondeador[i].total_inversion = this.inversiones_fondeador[i-1].total_inversion + this.inversiones_fondeador[i].monto_incremento + this.inversion.monto;
          }else if(this.inversiones_fondeador[i].monto_retiro){
            this.inversiones_fondeador[i].total_inversion = this.inversiones_fondeador[i-1].total_inversion - this.inversiones_fondeador[i].monto_retiro + this.inversion.monto;
          }
          else{
            this.inversiones_fondeador[i].total_inversion = this.inversiones_fondeador[i-1].total_inversion + this.inversion.monto;
          }
          this.inversiones_fondeador[i].pago_interes = ((this.inversiones_fondeador[i].total_inversion * 30) * this.inversiones_fondeador[i].tasa_interes_diaria);
          this.inversiones_fondeador[i].pago_despues_impuestos = 0;
        }
      }
    }

  }

  public calcularNuevaTablaAhorradores(){
    this.total_aportaciones = 0;
    this.rendimiento_total = 0;
    this.total_iva = 0;
    this.total_neto = 0;
    this.ahorro_total = 0;
    //Campos de fecha normal
    // var fecha = this.inversiones_fondeador[0].fecha_inicio_inversion.split(" ")[0];
    // var dia = parseInt(fecha.split("-")[2]);
    // var mes = parseInt(fecha.split("-")[1]);
    // var anio = parseInt(fecha.split("-")[0]);
    this.fechaTemp = new Date(this.inversiones_fondeador[0].fecha_inicio_inversion.replace(/-/g, '\/'));
    this.fechaTemp = this.fechaTemp.toISOString();
    this.fechaTemp = this.fechaTemp.split("T")[0];
    //Tasa interes
    //Se divide la tasa de interes entre 360 ya que es anual
    // var tasaInteres = ((this.inversion.tasa_interes/100)/360);

    //Se realizan cálculos para la tabla
    //Asignamos las fechas de pago
    for (let i = 0; i < this.inversiones_fondeador.length; i++) {
      //this.inversiones_fondeador[i].fecha_pago = (anio+"-"+mes+"-"+dia);
      this.inversiones_fondeador[i].pago_realizado = "";
      this.inversiones_fondeador[i].estatus_pago = "";

      this.inversiones_fondeador[i].mes_numero = i;
      //this.inversiones_fondeador[i].periodo_dias = (this.inversiones_fondeador[i].periodicidad * (i));
      this.inversiones_fondeador[i].periodo_dias = 0;
      if(i == 0){
        //Al iniciar no existe rendimiento
        this.inversiones_fondeador[i].fecha_pago = this.fechaTemp;
        this.inversiones_fondeador[i].aportacion = 0;
        this.inversiones_fondeador[i].capital = 0;
        this.inversiones_fondeador[i].interes_generado = 0;
        if(this.inversion.capitalizacion == 1){
          //Si capitaliza, acumula y retira al final
          this.inversiones_fondeador[i].interes_acumulado = 0;
        }else if(this.inversion.capitalizacion == 3){
          //No capitaliza, acumula y retira al final
          this.inversiones_fondeador[i].interes_acumulado = 0;
        }
        this.inversiones_fondeador[i].iva = (this.inversiones_fondeador[i].interes_generado * this.inversion.iva);
        this.inversiones_fondeador[i].neto_ciclo = (this.inversiones_fondeador[i].interes_generado -  this.inversiones_fondeador[i].iva);
        //Aquí no necesitamos saldo final
        this.inversiones_fondeador[i].saldo_final = (this.inversiones_fondeador[i].capital + this.inversiones_fondeador[i].rendimiento);
      }else if(i == this.inversiones_fondeador.length - 1){
        //En el último mes ya no se tiene monto de aportación
        //---Se calculan las fechas de pago---
        this.fechaTemp = new Date(this.inversiones_fondeador[i-1].fecha_pago);
        this.fechaTemp.setDate(this.fechaTemp.getDate() + this.inversiones_fondeador[i].periodicidad);
        this.fechaTemp = this.fechaTemp.toISOString();
        this.fechaTemp = this.fechaTemp.split("T")[0];
        this.inversiones_fondeador[i].fecha_pago = this.fechaTemp;
        // //Calculos de saldos y rendimiento
        if(this.inversion.capitalizacion == 1){
          //Si capitaliza, acumula y retira al final
          this.inversiones_fondeador[i].aportacion = 0;
          this.inversiones_fondeador[i].capital = 0;
          this.inversiones_fondeador[i].interes_generado = 0;
          this.inversiones_fondeador[i].interes_acumulado = 0;
        }else if(this.inversion.capitalizacion == 3){
          //No capitaliza, acumula y retira al final
          this.inversiones_fondeador[i].aportacion = 0;
          this.inversiones_fondeador[i].capital = 0;
          this.inversiones_fondeador[i].interes_generado = 0;
          this.inversiones_fondeador[i].interes_acumulado = 0;
        }
        this.inversiones_fondeador[i].iva = 0;
        this.inversiones_fondeador[i].neto_ciclo = 0;
        //No lleva saldo final
        //this.inversiones_fondeador[i].saldo_final = (this.inversiones_fondeador[i].capital + this.inversiones_fondeador[i].rendimiento);
        //Ahorro total
        this.ahorro_total = this.inversiones_fondeador[i].saldo_final;
        //El capital ahorrado es el último valor del capital
        this.total_aportaciones = 0;
      }else{
        console.log("ROW:"+i);
        //Demás meses se calculan en base a las reglas
        //---Se calculan las fechas de pago---
        this.fechaTemp = new Date(this.inversiones_fondeador[i-1].fecha_pago);
        this.fechaTemp.setDate(this.fechaTemp.getDate() + this.inversiones_fondeador[i].periodicidad);
        this.fechaTemp = this.fechaTemp.toISOString();
        this.fechaTemp = this.fechaTemp.split("T")[0];
        this.inversiones_fondeador[i].fecha_pago = this.fechaTemp;
        // //Calculos de saldos y rendimiento
        if(this.inversion.capitalizacion == 1){
          //Si capitaliza, acumula y retira al final
          this.inversiones_fondeador[i].capital = 0;
          this.inversiones_fondeador[i].aportacion = 0;
          this.inversiones_fondeador[i].interes_generado = 0;
          this.inversiones_fondeador[i].interes_acumulado = 0;
        }else if(this.inversion.capitalizacion == 3){
          //No capitaliza, acumula y retira al final
          this.inversiones_fondeador[i].aportacion = 0;
          this.inversiones_fondeador[i].capital = 0;
          this.inversiones_fondeador[i].interes_generado = 0;
          this.inversiones_fondeador[i].interes_acumulado = 0;
        }

        this.inversiones_fondeador[i].iva = 0;
        this.inversiones_fondeador[i].neto_ciclo = 0;
        //No lleva saldo final
        this.inversiones_fondeador[i].saldo_final = (this.inversiones_fondeador[i].capital + this.inversiones_fondeador[i].rendimiento);

      }
      this.pagos_de_ciclos.push({"ciclo":i,"min":this.fechaTemp})
      //this.total_aportaciones = this.total_aportaciones + this.inversiones_fondeador[i].monto;
      this.total_dias_transcurridos = this.total_dias_transcurridos + this.inversiones_fondeador[i].periodo_dias;
      this.rendimiento_total = this.rendimiento_total + this.inversiones_fondeador[i].interes_generado;
      this.total_iva = this.total_iva + this.inversiones_fondeador[i].iva;
      this.total_neto = this.total_neto + this.inversiones_fondeador[i].neto_ciclo;
    }
    console.log("Tabla final: ", this.inversiones_fondeador);
    this.obtenerPagosInversion();

  }

  public aplicarIncrementosBD(id: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.isLoading = true;
      
      this.fondeadoresService.getEsquemaInversionConIncrementos(id).subscribe(
        (response) => {
          const jsonResult = response.json();
  
          if (jsonResult.content.length > 0) {
            // this.lista_incrementos = jsonResult.content;
            // console.log("Json Incrementos : ", this.lista_incrementos);
            this.isLoading = false;
            resolve(jsonResult.content); // Resuelve la promesa con la lista de incrementos
          } else {
            console.log("No hay incrementos en esta inversión");
            this.isLoading = false;
            resolve([]); // Resuelve la promesa con un array vacío si no hay incrementos
          }
        },
        (error) => {
          this.isLoading = false;
          this.helperService.httpGlobalError(error);
  
          if (error.status == 400) {
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
  
          reject(error); // Rechaza la promesa con el error
        }
      );
    });
  }

  public obtenerDevolucionesInversion(id: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.isLoading = true;
      this.fondeadoresService.getEsquemaInversionConDevoluciones(id).subscribe(
        (response) => {
          const jsonResult = response.json();
  
          if (jsonResult.content.length > 0) {
            // this.lista_devoluciones = jsonResult.content;
            // console.log("Json devoluciones : ", this.lista_devoluciones);
            this.isLoading = false;
            resolve(jsonResult.content);
          } else {
            console.log("No hay devoluciones en esta inversión");
            this.isLoading = false;
            resolve([]); // Resolvemos la promesa con una lista vacía
          }
        }, 
        error => {
          // se resuelve error 403 y 500
          this.isLoading = false;
          this.helperService.httpGlobalError(error);
  
          if (error.status == 400) {
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
          reject(error); // Rechazamos la promesa con el error
        }
      );
    });
  }

  public calcularestimado(){
    this.total_estimado = 0;
    if(this.inversiones_fondeador[0].pago_realizado!=""){
      this.total_estimado = this.total_estimado + this.inversiones_fondeador[0].aportacion
    }else{
      this.total_estimado = this.total_estimado + this.inversion.monto
    }
    for (let i = 1; i < this.inversiones_fondeador.length; i++) {
      let anterior = this.inversiones_fondeador[i-1];
      let actual = this.inversiones_fondeador[i];
      if(actual.pago_realizado !=""){
        this.total_estimado = this.total_estimado + actual.aportacion
      }else{
        this.total_estimado = this.total_estimado + this.inversion.monto
      }
      //Al terminar de re-calcular la tabla, guardamos la info en la nueva tabla llamada esquema/estimados
    }
    this.total_estimado = this.total_estimado - this.inversion.monto
    let data = {
      "id_esquema":this.inversionId,
      "capital_ahorrado":this.total_aportaciones,
      "intereses_brutos":this.rendimiento_total.toFixed(2),
      "intereses_netos":this.total_neto.toFixed(2),
      "inversion_estimada":this.total_estimado.toFixed(2),
    }
    this.esquemaInversionService.guardarestimado(data).subscribe(
      (response)=>{
        console.info(response)
      },
      (error)=>{
        console.error(error)
      }
    )
  }
  //Intereses para ahorradores
  public actualizarIntereses(segunda_vuelta=false){
    if(this.inversion.tipo_producto == "ahorrador"){
      //Tasa interes
      if (segunda_vuelta){
        if(this.inversiones_fondeador[0].pago_realizado!=""){
          this.total_estimado = this.total_estimado + this.inversiones_fondeador[0].aportacion
        }else{
          this.total_estimado = this.total_estimado + this.inversion.monto
        }
        for (let i = 1; i < this.inversiones_fondeador.length; i++) {
          let anterior = this.inversiones_fondeador[i-1];
          let actual = this.inversiones_fondeador[i];
          switch(actual.tipo_retiro){
            case "intereses":
              console.log("retiro de interes");
              actual.capital = anterior.capital
              actual.interes_acumulado = 0
              //Puede que cambie si es que tiene IVA
              this.total_neto = this.total_neto - actual.monto_retirado
            break;
            case "capital":
              console.log("retiro de capital");
              actual.interes_acumulado = anterior.interes_acumulado
              actual.capital = anterior.capital - actual.monto_retirado
            break;
            default:

              if(actual.pago_realizado !=""){
                this.total_estimado = this.total_estimado + actual.aportacion
              }else{
                this.total_estimado = this.total_estimado + this.inversion.monto
              }

              if (actual.pago_realizado == "" && actual.periodo_dias != ""){
                this.total_dias_transcurridos -= actual.periodo_dias
                this.rendimiento_total = this.rendimiento_total - actual.interes_generado
                this.total_neto = this.total_neto - actual.interes_generado
              }
              actual.capital = anterior.capital + actual.aportacion
              actual.interes_acumulado = anterior.interes_acumulado + actual.interes_generado
            break;
          }
          //Al terminar de re-calcular la tabla, guardamos la info en la nueva tabla llamada esquema/estimados
        }
        this.total_estimado = this.total_estimado - this.inversion.monto
        let data = {
          "id_esquema":this.inversionId,
          "capital_ahorrado":this.total_aportaciones,
          "intereses_brutos":this.rendimiento_total.toFixed(2),
          "intereses_netos":this.total_neto.toFixed(2),
          "inversion_estimada":this.total_estimado.toFixed(2),
        }
        this.esquemaInversionService.guardarestimado(data).subscribe(
          (response)=>{
            console.info(response)
          },
          (error)=>{
            console.error(error)
          }
        )
      }else{
        //Si es la primera vez que se calcula, hacemos el proceso ya esablecido
        //Se divide la tasa de interes entre 360 ya que es anual
        var tasaInteres = ((this.inversion.tasa_interes/100)/360);
        //Se realizan cálculos para la tabla
        //Asignamos las fechas de pago
        for (let i = 0; i < this.inversiones_fondeador.length; i++) {
          if(this.inversiones_fondeador[i].pago_realizado != ""){
            console.log("Entro act intereses");

            if(i == 0){
              //Calcular diferencia de días entre la fecha de pago y la fecha del corte siguiente
              let fecha_corte: any;
              let fecha_pago = new Date(this.inversiones_fondeador[i].pago_realizado).getTime();
              if(this.inversiones_fondeador[i+1].pago_realizado != ""){
                //Si es un pago que no sea el último toma como fecha de corte la fecha siguiente en la que se pagó
                fecha_corte = new Date(this.inversiones_fondeador[i+1].pago_realizado).getTime();
              }else{
                //Si es el último pago se asigna la fecha de corte siguiente original
                fecha_corte = new Date(this.inversiones_fondeador[i+1].fecha_pago).getTime();
              }
              let diferencia = fecha_corte - fecha_pago;
              let dias_faltantes = Math.round(diferencia/(1000*60*60*24));
              this.inversiones_fondeador[i+1].periodo_dias = dias_faltantes;
              //console.log("Días faltantes: ", dias_faltantes);
              //Al iniciar no existe rendimiento
              //El capital se debe ir actualizando
              this.inversiones_fondeador[i].capital = this.inversiones_fondeador[i].aportacion;
              //Intereses
              this.inversiones_fondeador[i+1].interes_generado = this.redondeaADos(tasaInteres * (dias_faltantes * this.inversiones_fondeador[i].capital));
              if(this.inversion.capitalizacion == 1){
                //Si capitaliza, acumula y retira al final
                this.inversiones_fondeador[i+1].interes_acumulado = (this.inversiones_fondeador[i+1].interes_generado + this.inversiones_fondeador[i].interes_acumulado);
              }else if(this.inversion.capitalizacion == 3){
                //No capitaliza, acumula y retira al final
                this.inversiones_fondeador[i+1].interes_acumulado = (this.inversiones_fondeador[i+1].interes_generado + this.inversiones_fondeador[i].interes_acumulado);;
              }
              this.inversiones_fondeador[i+1].iva = (this.inversiones_fondeador[i+1].interes_generado * this.inversion.iva);
              this.inversiones_fondeador[i+1].neto_ciclo = (this.inversiones_fondeador[i+1].interes_generado -  this.inversiones_fondeador[i+1].iva);
              //Aquí no necesitamos saldo final
              //this.inversiones_fondeador[i].saldo_final = (this.inversiones_fondeador[i].capital + this.inversiones_fondeador[i].rendimiento);
            }else if(i == this.inversiones_fondeador.length - 1){
              //En el último mes ya no se tiene monto de aportación
              //Calculos de saldos y rendimiento
              if(this.inversion.capitalizacion == 1){
                //Si capitaliza, acumula y retira al final
                this.inversiones_fondeador[i].capital = (this.inversiones_fondeador[i-1].capital +  this.inversiones_fondeador[i].aportacion + this.inversiones_fondeador[i-1].interes_generado);
                // this.inversiones_fondeador[i].interes_generado = (tasaInteres * (dias_faltantes * this.inversiones_fondeador[i].capital));
                // this.inversiones_fondeador[i].interes_acumulado = (this.inversiones_fondeador[i].interes_generado + this.inversiones_fondeador[i-1].interes_acumulado);
              }else if(this.inversion.capitalizacion == 3){
                //No capitaliza, acumula y retira al final
                this.inversiones_fondeador[i].capital = this.inversiones_fondeador[i-1].capital + this.inversiones_fondeador[i].aportacion;
                // this.inversiones_fondeador[i].interes_generado =(tasaInteres * (dias_faltantes * this.inversiones_fondeador[i].capital));
                // this.inversiones_fondeador[i].interes_acumulado = (this.inversiones_fondeador[i].interes_generado + this.inversiones_fondeador[i-1].interes_acumulado);
              }
            }else{
              //Calcular diferencia de días entre la fecha de pago y la fecha del corte siguiente
              let fecha_corte: any;
              let fecha_pago = new Date(this.inversiones_fondeador[i].pago_realizado).getTime();
              if(this.inversiones_fondeador[i+1].pago_realizado != ""){
                //Si es un pago que no sea el último toma como fecha de corte la fecha siguiente en la que se pagó
                fecha_corte = new Date(this.inversiones_fondeador[i+1].pago_realizado).getTime();
              }else{
                //Si es el último pago se asigna la fecha de corte siguiente original
                fecha_corte = new Date(this.inversiones_fondeador[i+1].fecha_pago).getTime();
              }
              let diferencia = fecha_corte - fecha_pago;
              let dias_faltantes = Math.round(diferencia/(1000*60*60*24));
              this.inversiones_fondeador[i+1].periodo_dias = dias_faltantes;
              //console.log("Días faltantes i+: ", dias_faltantes);
              //Demás meses se calculan en base a las reglas
              //Calculos de saldos y rendimiento
              if(this.inversion.capitalizacion == 1){
                //Si capitaliza, acumula y retira al final
                this.inversiones_fondeador[i].capital = (this.inversiones_fondeador[i-1].capital +  this.inversiones_fondeador[i].aportacion + this.inversiones_fondeador[i-1].interes_generado);
                this.inversiones_fondeador[i+1].interes_generado = (tasaInteres * (dias_faltantes * this.inversiones_fondeador[i].capital));
                this.inversiones_fondeador[i+1].interes_acumulado = (this.inversiones_fondeador[i+1].interes_generado + this.inversiones_fondeador[i].interes_acumulado);
              }else if(this.inversion.capitalizacion == 3){
                //No capitaliza, acumula y retira al final
                this.inversiones_fondeador[i].capital = this.inversiones_fondeador[i-1].capital + this.inversiones_fondeador[i].aportacion;
                this.inversiones_fondeador[i+1].interes_generado = (tasaInteres * (dias_faltantes * this.inversiones_fondeador[i].capital));
                this.inversiones_fondeador[i+1].interes_acumulado = (this.inversiones_fondeador[i+1].interes_generado + this.inversiones_fondeador[i].interes_acumulado);
              }

              this.inversiones_fondeador[i+1].iva = (this.inversiones_fondeador[i+1].interes_generado * this.inversion.iva);
              this.inversiones_fondeador[i+1].neto_ciclo = (this.inversiones_fondeador[i+1].interes_generado -  this.inversiones_fondeador[i+1].iva);
              //No lleva saldo final
              //this.inversiones_fondeador[i].saldo_final = (this.inversiones_fondeador[i].capital + this.inversiones_fondeador[i].rendimiento);

            }
            // --------------Revisar-----------------
            //Se calcula todo
            //Calcular sumatorias que van al final de la tabla
            this.total_aportaciones = this.total_aportaciones + this.inversiones_fondeador[i].aportacion;
            this.total_dias_transcurridos = this.total_dias_transcurridos + this.inversiones_fondeador[i].periodo_dias;
            this.rendimiento_total = this.rendimiento_total + this.inversiones_fondeador[i].interes_generado;
            this.total_iva = this.total_iva + this.inversiones_fondeador[i].iva;
            this.total_neto = this.total_neto + this.inversiones_fondeador[i].neto_ciclo;

          }else{
            this.total_dias_transcurridos = this.total_dias_transcurridos + this.inversiones_fondeador[i].periodo_dias;
            this.rendimiento_total = this.rendimiento_total + this.inversiones_fondeador[i].interes_generado;
            this.total_iva = this.total_iva + this.inversiones_fondeador[i].iva;
            this.total_neto = this.total_neto + this.inversiones_fondeador[i].neto_ciclo;
            break;
          }
        }
        console.log(this.total_neto.toFixed(2))
        this.limpiarCeros();
        console.log("Tabla final: ", this.inversiones_fondeador);
        // console.log(this.inversiones_fondeador[12]);
        if (this.inversion.estatus_completado){
          var last_i = this.inversiones_fondeador.length-1;
          this.total_dias_transcurridos = this.total_dias_transcurridos + this.inversiones_fondeador[last_i].periodo_dias;
          this.rendimiento_total = this.rendimiento_total + this.inversiones_fondeador[last_i].interes_generado;
          this.total_iva = this.total_iva + this.inversiones_fondeador[last_i].iva;
          this.total_neto = this.total_neto + this.inversiones_fondeador[last_i].neto_ciclo;
        }
      }
    }else if(this.inversion.tipo_producto == "inversionista"){
      //Realizar lógica para inversionistas ------------------ Pendiente ---------------------
    }
  }

  public limpiarCeros(){
    for (let i = 1; i < this.inversiones_fondeador.length; i++) {
      if(this.inversiones_fondeador[i].periodo_dias == 0){
        this.inversiones_fondeador[i].periodo_dias = "";
      }

      if(this.inversiones_fondeador[i].aportacion == 0){
        this.inversiones_fondeador[i].aportacion = "";
      }

      if(this.inversiones_fondeador[i].capital == 0){
        this.inversiones_fondeador[i].capital = "";
      }

      if(this.inversiones_fondeador[i].interes_generado == 0){
        this.inversiones_fondeador[i].interes_generado = "";
      }

      if(this.inversiones_fondeador[i].interes_acumulado == 0){
        this.inversiones_fondeador[i].interes_acumulado = "";
      }

      if(this.inversiones_fondeador[i].periodo_dias == ''){
        if(this.inversiones_fondeador[i].iva == 0){
          this.inversiones_fondeador[i].iva = "";
        }
      }

      if(this.inversiones_fondeador[i].neto_ciclo == 0){
        this.inversiones_fondeador[i].neto_ciclo = "";
      }

    }
  }

  public getDevolucionesAhorrador(){
    //Solo se realiza si se tienen devoluciones
    if(this.lista_devoluciones.length > 0){
      let total_devoluciones_capital = 0;
      let total_devoluciones_interes = 0;
      this.lista_devoluciones.forEach((devolucion, index) => {
        const fechaDevolucion = new Date(devolucion.fecha_devolucion_inversion).toISOString();
        for (let j = 0; j < this.inversiones_fondeador.length; j++) {
          const fechaPago = new Date(this.inversiones_fondeador[j].fecha_pago).toISOString();
          if( j < this.inversiones_fondeador.length-1){
            //console.log("J: ",j);
            if(this.inversiones_fondeador[j].fecha_pago != ""){
              const fechaPagoSig = new Date(this.inversiones_fondeador[j+1].fecha_pago).toISOString();
              if(fechaDevolucion >= fechaPago && fechaDevolucion < fechaPagoSig){
                //Agregamos nuevos valores a la tabla
                let jsonTempDev = (Object.assign({} , this.inversiones_fondeador[j]));

                jsonTempDev.idRetiro = devolucion.idDevolucionInversion;
                jsonTempDev.monto_retirado = devolucion.monto_retiro;
                jsonTempDev.fecha_retiro_intereses = devolucion.fecha_devolucion_inversion;
                jsonTempDev.tipo_retiro = devolucion.tipo_retiro;

                //Se limpian los campos para no mostrar en la tabla
                this.limpiarCamposDevolucionesAhorrador(jsonTempDev);

                this.inversiones_fondeador.splice(j+1,0,jsonTempDev);

                console.log(this.inversiones_fondeador);
                break;
              }
            }

          }
          if( j === this.inversiones_fondeador.length-1){
            if( index === this.lista_incrementos.length-1){
              // console.log("FIncremento: ", fechaIncremento);
              // console.log("Pago: ",fechaPago);
              if(fechaDevolucion >= fechaPago){
                //Agregamos nuevos valores a la tabla
                let jsonTempDev = (Object.assign({} , this.inversiones_fondeador[j]));
                jsonTempDev.idRetiro = devolucion.idDevolucionInversion;
                jsonTempDev.monto_retirado = devolucion.monto_retiro;
                jsonTempDev.fecha_retiro_intereses = devolucion.fecha_devolucion_inversion;
                jsonTempDev.tipo_retiro = devolucion.tipo_retiro;

                //Se limpian los campos para no mostrar en la tabla
                this.limpiarCamposDevolucionesAhorrador(jsonTempDev);

                this.inversiones_fondeador.push(jsonTempDev);
                break;
              }

            }
          }

        }
        //Obtenemos el total del capital retirado
        if(devolucion.tipo_retiro == 'capital'){
          total_devoluciones_capital = this.redondeaADos(total_devoluciones_capital) + this.redondeaADos(devolucion.monto_retiro);
        }else if(devolucion.tipo_retiro == 'intereses'){
          //Obtenemos el total de intereses por todos los retiros
          total_devoluciones_interes = this.redondeaADos(total_devoluciones_interes) + this.redondeaADos(devolucion.monto_retiro);
          console.log(total_devoluciones_interes);
        }
      });
      //Actualizamos el capital o los intereses netos
      this.total_aportaciones = this.redondeaADos(this.total_aportaciones) - this.redondeaADos(total_devoluciones_capital);
      this.rendimiento_total = this.redondeaADos(this.rendimiento_total) - this.redondeaADos(total_devoluciones_interes)
      // this.total_neto = this.redondeaADos(this.total_neto) - this.redondeaADos(total_devoluciones_interes);

    }
  }

  public redondeaATres(data){
    return Math.round((data + Number.EPSILON) * 10000) / 10000;
  }

  public redondeaADos(data){
    return Math.round((data + Number.EPSILON) * 100) / 100;
  }
  public limpiarCamposDevolucionesAhorrador(json: any){
    //Agregamos al arreglo los cambios de inversión
    json.fecha_pago = null;
    json.pago_realizado = null;
    json.mes_numero = null;
    json.periodo_dias = null;
    json.aportacion = null;
    json.capital = null;
    json.interes_generado = null;
    json.interes_acumulado = null;
    json.iva = null;
    json.neto_ciclo = null;
    json.estatus_pago = null;
    json.num_referencia = null;

  }

  public obtenerPagosInversion(){
    this.isLoading = true;
    if(this.inversion.tipo_producto == "inversionista" && (this.inversion.capitalizacion == 1 || this.inversion.capitalizacion == 3) && !this.inversion.estatus_completado){
      var nuevo_total=0;
      var nuevo_total_impuestos=0;
      for (let i = 0; i < this.inversiones_fondeador.length; i++){
        this.total_inversion = this.inversiones_fondeador[i].total_inversion
        nuevo_total += this.inversiones_fondeador[i].pago_interes
        nuevo_total_impuestos += this.inversiones_fondeador[i].pago_interes * (this.inversion.iva + 1)
        console.info(nuevo_total_impuestos)
      }
      this.total_intereses += nuevo_total
      // if (this.inversion.retencion_impuestos != "no"){
      //   console.log("OTRO")
        this.total_despues_impuestos = nuevo_total_impuestos
      // }
      this.pagosFondeadoresService.getPagosInversionById(this.inversionId).subscribe(
        (response)=>{
          const jsonResult = response.json();
          if(jsonResult.content.length > 0){
            this.lista_pagos = jsonResult.content;
            this.total_inversion = 0; // Ver si esto arregla lo que se vea como si tuvo 2 depositos y si no genera ás problemas
            for (let i = 0; i < this.lista_pagos.length; i++) {
              this.inversiones_fondeador[this.lista_pagos[i].numero_ciclo].pago_realizado = this.lista_pagos[i].fecha_pago;
              this.inversiones_fondeador[this.lista_pagos[i].numero_ciclo].estatus_pago = "Pagado";
              this.inversiones_fondeador[this.lista_pagos[i].numero_ciclo].num_referencia = this.lista_pagos[i].num_referencia;
              this.inversiones_fondeador[this.lista_pagos[i].numero_ciclo].idPago = this.lista_pagos[i].id;
              if (this.lista_pagos[i].numero_ciclo == 0){
                this.inversiones_fondeador[this.lista_pagos[i].numero_ciclo].total_inversion = this.lista_pagos[i].monto_pago;
              }else{
                this.inversiones_fondeador[this.lista_pagos[i].numero_ciclo].pago_interes = this.lista_pagos[i].monto_pago;  
              }
              // this.inversiones_fondeador[this.lista_pagos[i].numero_ciclo].pago_interes = this.lista_pagos[i].monto_pago;
              if (this.lista_pagos[i].numero_ciclo != 0){
                this.total_intereses += this.lista_pagos[i].monto_pago
                this.total_despues_impuestos += this.lista_pagos[i].monto_pago * this.inversion.iva;
              }else{
                this.total_inversion += this.lista_pagos[i].monto_pago
              }
            }
            if (this.lista_incrementos.length != 0){
              for (let index = 0; index < this.lista_incrementos.length; index++) {
                const element = this.lista_incrementos[index];
                this.total_inversion += element.monto_incremento
              }
            }
            //TODO: Posiblemente hay que revisar las devoluciones antes de terminar de repintar todo así que puede ir aqui abajo
            if(this.inversiones_fondeador[this.inversiones_fondeador.length-1].estatus_pago == "Pagado"){
              console.log("Se completó el esquema");
              this.esquemaCompletado();
            }
          }else{

            this.pagosFondeadoresService.getPagosInversionById(this.inversionId).subscribe(
              (response)=>{
                const jsonResult = response.json();
                if(jsonResult.content.length > 0){
                  this.pagos=true;
                  this.lista_pagos = jsonResult.content;
                  console.log("Json pagos : ",this.lista_pagos);
                  //Comprobar si el esquema ha finalizado
                  //Si se cumplen todos los pagos finaliza el esquema de inversión
                  if(this.inversion.tipo_producto == "inversionista"){
                    this.pago_inicial = false;
                    //Ïnsertar pagos a la tabla de inversiones
                    this.total_intereses = 0;
                    for (let i = 0; i < this.lista_pagos.length; i++) {
                      this.inversiones_fondeador[this.lista_pagos[i].numero_ciclo].pago_realizado = this.lista_pagos[i].fecha_pago;
                      this.inversiones_fondeador[this.lista_pagos[i].numero_ciclo].estatus_pago = "Pagado";
                      this.inversiones_fondeador[this.lista_pagos[i].numero_ciclo].num_referencia = this.lista_pagos[i].num_referencia;
                      this.inversiones_fondeador[this.lista_pagos[i].numero_ciclo].idPago = this.lista_pagos[i].id;
                      if (this.lista_pagos[i].numero_ciclo == 0){
                        this.inversiones_fondeador[this.lista_pagos[i].numero_ciclo].total_inversion = this.lista_pagos[i].monto_pago;
                      }else{
                        this.inversiones_fondeador[this.lista_pagos[i].numero_ciclo].pago_interes = this.lista_pagos[i].monto_pago;  
                      }
                      // this.inversiones_fondeador[this.lista_pagos[i].numero_ciclo].pago_interes = this.lista_pagos[i].monto_pago;
                      if (this.lista_pagos[i].numero_ciclo != 0){
                        this.total_intereses += this.lista_pagos[i].monto_pago
                        this.total_despues_impuestos += this.lista_pagos[i].monto_pago * this.inversion.iva;
                      }else{
                        this.total_inversion += this.lista_pagos[i].monto_pago
                      }
                    }
                    //Verificar si terminó el esquema
                    if(this.inversiones_fondeador[this.inversiones_fondeador.length-1].estatus_pago == "Pagado"){
                      console.log("Se completó el esquema");
                      this.esquemaCompletado();
                    }
                  }else if(this.inversion.tipo_producto == "ahorrador"){
                    //Calculamos tabla con pagos
                    //Verificamos si ya existe algún pago en ese ciclo
                    let num_ciclo = 0;
      
                    for (let index = 0; index < this.lista_pagos.length; index++) {
                      const pago = this.lista_pagos[index];
                      //Verificamos que coincida el número de ciclo
                      for (let i = 0; i < this.inversiones_fondeador.length; i++) {
                        if(this.inversiones_fondeador[i].mes_numero == pago.numero_ciclo){
                          num_ciclo = i;
                          break;
                        }else{
                          num_ciclo = i+1;
                          //break;
                        }
                      }
        
                      //Si es el primer pago se inserta
                      if(index == 0){
                        //En primer lugar se asigna la fecha de pago
                        this.inversiones_fondeador[num_ciclo].pago_realizado = pago.fecha_pago;
                        //Se colocan montos
                        this.inversiones_fondeador[num_ciclo].aportacion = pago.monto_pago;
                        this.inversiones_fondeador[num_ciclo].estatus_pago = "Pagado";
                        this.inversiones_fondeador[num_ciclo].idPago = pago.id;
                        this.inversiones_fondeador[num_ciclo].num_referencia = pago.num_referencia;
                      }else{
                        //Se evaluan las fechas entre rangos para saber donde insertar
                        if(this.inversiones_fondeador[num_ciclo].pago_realizado == ""){
                          //Si el pago es vacío
                          this.inversiones_fondeador[num_ciclo].pago_realizado = pago.fecha_pago;
                          //Se colocan montos
                          this.inversiones_fondeador[num_ciclo].aportacion = pago.monto_pago;
                          this.inversiones_fondeador[num_ciclo].estatus_pago = "Pagado";
                          this.inversiones_fondeador[num_ciclo].idPago = pago.id;
                          this.inversiones_fondeador[num_ciclo].num_referencia = pago.num_referencia;
                        }else{
                          console.log("Entro al else de no vacio");
                          //Hacemos un respaldo del json
                          let jsonNuevoPago = (Object.assign({} , this.inversiones_fondeador[num_ciclo]));
                          jsonNuevoPago.pago_realizado = pago.fecha_pago;
                          jsonNuevoPago.aportacion = pago.monto_pago;
                          jsonNuevoPago.estatus_pago = "Pagado";
                          jsonNuevoPago.idPago = pago.id;
                          jsonNuevoPago.num_referencia = pago.num_referencia;
        
                          //Limpiamos algunos campos
                          jsonNuevoPago.fecha_pago = null;
                          jsonNuevoPago.mes_numero = null;
                          jsonNuevoPago.periodo_dias = null;
        
                          this.inversiones_fondeador.splice(num_ciclo+1,0,jsonNuevoPago);
                        }
                      }
                    }
                    // this.lista_pagos.forEach((pago, index)=>{
                      
                    // });
        
                    //Actualizamos intereses de la tabla
                    this.actualizarIntereses();
                    this.getDevolucionesAhorrador();
                    this.actualizarIntereses(true);
                    this.calcularestimado();
                    //Verificamos si terminó el esquma
                    if(this.inversiones_fondeador[this.inversiones_fondeador.length-2].estatus_pago == "Pagado"){
                      this.todo_pagado = true;
                      if(this.finEsquemaAhorro){
                        console.log("Se completó el esquema");
                        this.esquemaCompletado();
                      }else{
                        alert("El esquema finaliza en "+this.dias_restantes+" días");
                      }
                    }
                  }
                  this.isLoading = false;
                }else{
                  this.pagos=false;
                  console.log("No hay pagos en esta inversión");
                  this.pago_inicial = true;
                  this.limpiarCeros();
                }
        
              }, error =>
              {
                // se resuelve error 403 y 500
                this.isLoading = false;
                this.helperService.httpGlobalError(error);
        
                if(error.status == 400) {
                  this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
                }
              }
            );
          }
        }
      )
    }else{

      this.pagosFondeadoresService.getPagosInversionById(this.inversionId).subscribe(
        (response)=>{
          const jsonResult = response.json();
          if(jsonResult.content.length > 0){
            this.pagos=true;
            this.lista_pagos = jsonResult.content;
            console.log("Json pagos : ",this.lista_pagos);
            //Comprobar si el esquema ha finalizado
            //Si se cumplen todos los pagos finaliza el esquema de inversión
            if(this.inversion.tipo_producto == "inversionista"){
              this.pago_inicial = false;
              this.total_inversion = 0; // Ver si esto arregla lo que se vea como si tuvo 2 depositos
              //Ïnsertar pagos a la tabla de inversiones
              this.total_intereses = 0;
              for (let i = 0; i < this.lista_pagos.length; i++) {
                this.inversiones_fondeador[this.lista_pagos[i].numero_ciclo].pago_realizado = this.lista_pagos[i].fecha_pago;
                this.inversiones_fondeador[this.lista_pagos[i].numero_ciclo].estatus_pago = "Pagado";
                this.inversiones_fondeador[this.lista_pagos[i].numero_ciclo].num_referencia = this.lista_pagos[i].num_referencia;
                this.inversiones_fondeador[this.lista_pagos[i].numero_ciclo].idPago = this.lista_pagos[i].id;
                if (this.lista_pagos[i].numero_ciclo == 0){
                  this.inversiones_fondeador[this.lista_pagos[i].numero_ciclo].total_inversion = this.lista_pagos[i].monto_pago;
                }
                // this.inversiones_fondeador[this.lista_pagos[i].numero_ciclo].pago_interes = this.lista_pagos[i].monto_pago;
                if (this.lista_pagos[i].numero_ciclo != 0){
                  if (this.lista_pagos[i].monto_pago != this.inversiones_fondeador[this.lista_pagos[i].numero_ciclo].pago_despues_impuestos){
                    this.inversiones_fondeador[this.lista_pagos[i].numero_ciclo].pago_despues_impuestos = this.lista_pagos[i].monto_pago;
                    this.inversiones_fondeador[this.lista_pagos[i].numero_ciclo].pago_interes = this.lista_pagos[i].monto_pago/(1-this.inversion.tasa_retencion_diaria);
                  }
                  this.total_intereses += this.lista_pagos[i].monto_pago
                  this.total_despues_impuestos += this.lista_pagos[i].monto_pago * this.inversion.iva;
                }else{
                  this.total_inversion += this.lista_pagos[i].monto_pago
                }
              }
              if (this.lista_incrementos.length != 0){
                for (let index = 0; index < this.lista_incrementos.length; index++) {
                  const element = this.lista_incrementos[index];
                  this.total_inversion += element.monto_incremento
                }
              }
              //TODO: Posiblemente hay que revisar las devoluciones antes de terminar de repintar todo así que puede ir aqui abajo
              //Verificar si terminó el esquema
              if(this.inversiones_fondeador[this.inversiones_fondeador.length-1].estatus_pago == "Pagado"){
                console.log("Se completó el esquema");
                this.esquemaCompletado();
              }
            }else if(this.inversion.tipo_producto == "ahorrador"){
              //Calculamos tabla con pagos
              //Verificamos si ya existe algún pago en ese ciclo
              let num_ciclo = 0;

              for (let index = 0; index < this.lista_pagos.length; index++) {
                const pago = this.lista_pagos[index];
                //Verificamos que coincida el número de ciclo
                for (let i = 0; i < this.inversiones_fondeador.length; i++) {
                  if(this.inversiones_fondeador[i].mes_numero == pago.numero_ciclo){
                    num_ciclo = i;
                    break;
                  }else{
                    num_ciclo = i+1;
                    //break;
                  }
                }
  
                //Si es el primer pago se inserta
                if(index == 0){
                  //En primer lugar se asigna la fecha de pago
                  this.inversiones_fondeador[num_ciclo].pago_realizado = pago.fecha_pago;
                  //Se colocan montos
                  this.inversiones_fondeador[num_ciclo].aportacion = pago.monto_pago;
                  this.inversiones_fondeador[num_ciclo].estatus_pago = "Pagado";
                  this.inversiones_fondeador[num_ciclo].idPago = pago.id;
                  this.inversiones_fondeador[num_ciclo].num_referencia = pago.num_referencia;
                }else{
                  //Se evaluan las fechas entre rangos para saber donde insertar
                  if(this.inversiones_fondeador[num_ciclo].pago_realizado == ""){
                    //Si el pago es vacío
                    this.inversiones_fondeador[num_ciclo].pago_realizado = pago.fecha_pago;
                    //Se colocan montos
                    this.inversiones_fondeador[num_ciclo].aportacion = pago.monto_pago;
                    this.inversiones_fondeador[num_ciclo].estatus_pago = "Pagado";
                    this.inversiones_fondeador[num_ciclo].idPago = pago.id;
                    this.inversiones_fondeador[num_ciclo].num_referencia = pago.num_referencia;
                  }else{
                    console.log("Entro al else de no vacio");
                    //Hacemos un respaldo del json
                    let jsonNuevoPago = (Object.assign({} , this.inversiones_fondeador[num_ciclo]));
                    jsonNuevoPago.pago_realizado = pago.fecha_pago;
                    jsonNuevoPago.aportacion = pago.monto_pago;
                    jsonNuevoPago.estatus_pago = "Pagado";
                    jsonNuevoPago.idPago = pago.id;
                    jsonNuevoPago.num_referencia = pago.num_referencia;
  
                    //Limpiamos algunos campos
                    jsonNuevoPago.fecha_pago = null;
                    jsonNuevoPago.mes_numero = null;
                    jsonNuevoPago.periodo_dias = null;
  
                    this.inversiones_fondeador.splice(num_ciclo+1,0,jsonNuevoPago);
                  }
                }
              }
              // this.lista_pagos.forEach((pago, index)=>{
                
              // });
  
              //Actualizamos intereses de la tabla
              this.actualizarIntereses();
              this.getDevolucionesAhorrador();
              this.actualizarIntereses(true);
              this.calcularestimado();
              //Verificamos si terminó el esquma
              if(this.inversiones_fondeador[this.inversiones_fondeador.length-2].estatus_pago == "Pagado"){
                this.todo_pagado = true;
                if(this.finEsquemaAhorro){
                  console.log("Se completó el esquema");
                  this.esquemaCompletado();
                }else{
                  alert("El esquema finaliza en "+this.dias_restantes+" días");
                }
              }
            }
            this.isLoading = false;
          }else{
            this.pagos=false;
            console.log("No hay pagos en esta inversión");
            this.pago_inicial = true;
            this.limpiarCeros();
          }
  
        }, error =>
        {
          // se resuelve error 403 y 500
          this.isLoading = false;
          this.helperService.httpGlobalError(error);
  
          if(error.status == 400) {
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        }
      );
    }
  }

  public esquemaCompletado(){
    this.rendimiento_ganado = 0;
    if(this.inversion.tipo_producto == "inversionista"){
      var total_intereses = 0;
      //Capitaliza intereses y no retiene impuestos
      if(this.inversion.capitalizacion == 1 && this.inversion.retencion_impuestos == "no"){
        this.rendimiento_ganado = (this.inversiones_fondeador[this.inversiones_fondeador.length-1].total_inversion + this.inversiones_fondeador[this.inversiones_fondeador.length-1].pago_interes);
        console.log("Si capitaliza y no retiene impuestos ", this.rendimiento_ganado);
      }else if(this.inversion.capitalizacion == 1 && this.inversion.retencion_impuestos == "si"){
        this.rendimiento_ganado = (this.inversiones_fondeador[this.inversiones_fondeador.length-1].total_inversion + this.inversiones_fondeador[this.inversiones_fondeador.length-1].pago_despues_impuestos);
        console.log("Si capitaliza y si retiene impuestos ", this.rendimiento_ganado);
      }else if(this.inversion.capitalizacion == 2 && this.inversion.retencion_impuestos == "no"){
        for (let i = 1; i < this.inversiones_fondeador.length; i++) {
          if(this.inversiones_fondeador[i].monto_incremento || this.inversiones_fondeador[i].monto_retiro){
            //Se ignoran estos casos
          }else{
            total_intereses = (total_intereses + this.inversiones_fondeador[i].pago_interes);
          }
        }
        for (let i = 1; i < this.lista_pagos.length; i++) {
          const element = this.lista_pagos[i];
          total_intereses -= element.monto_pago
        }
        this.rendimiento_ganado = (this.inversiones_fondeador[this.inversiones_fondeador.length-1].total_inversion + total_intereses);
        console.log("No capitaliza y no retiene impuestos caso 2", this.rendimiento_ganado);
      }else if(this.inversion.capitalizacion == 3 && this.inversion.retencion_impuestos == "no"){
        this.rendimiento_ganado = this.inversiones_fondeador[this.inversiones_fondeador.length-1].total_inversion
        console.log("No capitaliza y no retiene impuestos cas0 3", this.rendimiento_ganado);
      }
    }else if(this.inversion.tipo_producto == "ahorrador"){
      console.log("info extra", this.inversiones_fondeador[this.inversiones_fondeador.length-1].capital, this.inversiones_fondeador[this.inversiones_fondeador.length-1].interes_acumulado)
      this.rendimiento_ganado = parseFloat(this.inversiones_fondeador[this.inversiones_fondeador.length-1].capital) + this.inversiones_fondeador[this.inversiones_fondeador.length-1].interes_acumulado
      console.log("Vamos a regresar:", this.rendimiento_ganado)
      // this.rendimiento_ganado = this.total_aportaciones + this.rendimiento_total;
    }

    var datatemp = {
      "idEsquemaInversion": this.inversion.idEsquemaInversion,
      "idFondeador": this.inversion.idFondeador,
      "idSocio": this.inversion.idSocio,
      "monto_total": this.rendimiento_ganado
    }
    console.log(datatemp);
    if(!this.inversion.estatus_completado){
      //Armamos el json data
      var data = {
        "idEsquemaInversion": this.inversion.idEsquemaInversion,
        "idFondeador": this.inversion.idFondeador,
        "idSocio": this.inversion.idSocio,
        "monto_total": this.rendimiento_ganado
      }

      console.log("Data finalizar: ", data);
      //Registrar esquema finalizado
      this.esquemaInversionService.finalizarEsquemaInversion(data).subscribe(
        (response)=>
        {
          const respuesta = response.json();
          if (respuesta.success) {
            var monto_obtenido = new Intl.NumberFormat('en-US', {style: 'currency',currency: 'USD', minimumFractionDigits: 2}).format(this.rendimiento_ganado);
            this.helperService.notification('Esquema finalizado', 'Se ha completado el producto de inversión, el total devuelto al saldo a la vista es: '+monto_obtenido, 'success');
            //Poner dentro del success response
            setTimeout(() => {window.location.reload()},3000);
          }

        }, error =>
        {
          // se resuelve error 403 y 500
          this.isLoading = false;
          this.helperService.httpGlobalError(error);

          if(error.status == 400) {
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        }
      );
    }
  }

  //Acciones para pagos
  public actualizarPagos(idPago: number){
    console.log("PagoAct: ", idPago);
    //Abrimos el modal de pagos
    const dialogRef = this.dialog.open(PagosInversionModalComponent,{
      data: {pago_id: idPago, inversiones: this.inversiones_fondeador, idEsquema: this.inversionId, idFondeador: this.fondeadorID, saldo: this.inversion.saldo_disponible, intereses: this.total_intereses, pago_final: this.isRetiroFinal, editar: true},
      height: 'auto',
      width: '30vw',
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result.pagado){
        console.log("Pago actualizado: ", result.datos_pago);
        setTimeout(() => {
          window.location.reload();
        }, 3000);
        // this.obtInversionId(this.inversionId);
        // this.obtenerPagosInversion();
      }
    });
  }

  public eliminarPagos(idPago: number){
    console.log("PagoEliminar: ", idPago);
    const dialogRef = this.dialog.open(EliminarPagoModalComponent, {
      height: '70vh',
      width: '20vw',
      data: {pago_id:  idPago}
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result.eliminar){
        window.location.reload();
      }
    });
  }

  //Acciones para retiros
  public actualizarRetiros(idRetiro: number){
    console.log("ID Retiro: ", idRetiro);
    const dialogRef = this.dialog.open(DevolucionesInversionModalComponent,{
      data: {retiro_id: idRetiro, inversiones: this.inversion, total_inversion:  this.total_inversion, intereses: this.total_neto, capital: this.total_aportaciones, intereses_desp_impuestos: this.total_despues_impuestos, editar: true },
      height: 'auto',
      width: 'auto',
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result.devolucion){
        console.log("Retiro realizado: ", result.datosRetiro);
        //let incremento_inversion = result.datosIncremento;
        setTimeout(() => {window.location.reload()},3000);
      }
    });
  }

  public eliminarRetiros(idRetiro: number){
    console.log("ID Retiro: ", idRetiro);
    const dialogRef = this.dialog.open(EliminarRetiroModalComponent, {
      height: '70vh',
      width: '20vw',
      data: {retiro_id:  idRetiro}
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result.eliminar){
        window.location.reload();
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/administracion/fondeadores/detalles-inversion/detalles-inversion.component.ts